module.exports = __webpack_public_path__ + "img/710.709db4e2.png";